import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/pv-audits-inspections-quality-system-management")({
  head: () => buildRouteHead("/en/services/one-vigilance/pv-audits-inspections-quality-system-management", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/pv-audits-inspections-quality-system-management", replace: true });
  },
});
